module.exports = __webpack_public_path__ + "img/schlauch_comb_px.5e9d5ec4.png";